import React from 'react';

const SuiteSection=({eyebrow,title,children,className='',id})=> {
  const displayTitle=title?.replace(/&Automation/g,'& Automation');

  return (
    <section id={id} className={`px-4 py-20 sm:px-8 md:py-28 ${className}`}>
      <div className="mx-auto max-w-6xl">
        {(eyebrow || displayTitle) && (
          <div className="mb-10 max-w-3xl">
            {eyebrow && (
              <p className="mb-4 font-sans text-xs font-black uppercase tracking-[0.24em] text-neutral-600">
                {eyebrow}
              </p>
            )}
            {displayTitle && (
              <h2 className="text-3xl font-black uppercase leading-[0.98] tracking-tight text-black sm:text-4xl md:text-5xl">
                {displayTitle}
              </h2>
            )}
          </div>
        )}
        {children}
      </div>
    </section>
  );
};

export default SuiteSection;